import { Component } from '@angular/core';
import { Router, RouteConfigLoadStart, RouteConfigLoadEnd, RouterEvent, NavigationStart, NavigationEnd, Event, NavigationCancel, 
  NavigationError } from '@angular/router';

  import { NgxSpinnerService } from 'ngx-spinner';
  
  import { SharedService } from './shared/services/shared.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'VMS Client POC';
  loading: boolean = false;
  ipAddress: string;
  
  constructor(public router: Router, private spinner: NgxSpinnerService, public sharedService:SharedService) {

    // this.spinner.show();
    // setTimeout(() => {
    //   this.spinner.hide();
    // }, 1000);

  // setInterval(() =>  this.checkSessionTimeout(), 60000);
   
  
    router.events.subscribe(
      (event: RouterEvent): void => {
        if (event instanceof RouteConfigLoadStart) {
          this.loading = true;
        } else if (event instanceof RouteConfigLoadEnd) {
          this.loading = false;
        }
      }
    );

    router.events.forEach((event) => {
      if (event instanceof NavigationStart) {
         if ((event['url'] == '/login') || (event['url'] == '/')|| (event['url'] == '/register')|| (event['url'] == '/register-profile')|| (event['url'] == '/forgot-password') || (event['url'] == '/users/new-user-change-password')) {
         // this.show = false;
         //console.log('Session app' + event['url'] );
         }
         else {
          var isTokenAvailable = this.sharedService.isTokenAvailable();
         
          if(isTokenAvailable){
          setInterval(() =>  this.checkSessionTimeout(), 60000);
          }
         }
        }
    });
  }

  ngOnInit(): void {
    window.addEventListener('storage', (event) => {
      if (event.storageArea == localStorage) {
           let token = localStorage.getItem('VMS');
           if(token == undefined) { 
             // Perform logout
             //Navigate to login/home
              this.router.navigate(['/login']); 
           }
      }
  });
   // this.checkSessionTimeout();
   this.getIP();
  }

  getIP()  
  {  
    this.sharedService.getIPAddress().subscribe((res:any)=>{  
      this.ipAddress=res.ip;  
      //console.log(res.ip);
    });  
  }  
  
  checkSessionTimeout()
  {

    var isTokenAvailable = this.sharedService.isTokenAvailable();
    //console.log('Session app' + isTokenAvailable);
    if(isTokenAvailable){
      var result = this.sharedService.checkSessionTimeout();
     // console.log('Session app' + result);
       if(!result) {
         localStorage.removeItem('VMS');
         localStorage.clear();
        // this.router.navigateByUrl('/login');
         this.router.navigateByUrl('/', {skipLocationChange: true}).then(() => {
          this.router.navigate(['/login']);
      });
       }
    } 
   
  }

  

}
